/**
 * Browser notification helper.
 * - Yêu cầu permission 1 lần đầu
 * - Hiển thị native OS notification khi app chạy background
 * - Không hiện nếu user đang active ở tab này (focused)
 */

let permissionRequested = false;

export const notifyService = {
  /** Xin permission (chỉ hoạt động khi user gesture — gọi trong click handler) */
  async requestPermission(): Promise<NotificationPermission> {
    if (typeof Notification === 'undefined') return 'denied';
    if (Notification.permission !== 'default') return Notification.permission;
    if (permissionRequested) return Notification.permission;

    permissionRequested = true;
    try {
      return await Notification.requestPermission();
    } catch {
      return 'denied';
    }
  },

  /** Hiện notification. Bỏ qua nếu tab đang focused hoặc chưa có permission. */
  show(title: string, options?: NotificationOptions & { onClick?: () => void }) {
    if (typeof Notification === 'undefined') return;
    if (Notification.permission !== 'granted') return;
    if (document.visibilityState === 'visible' && document.hasFocus()) return;

    try {
      const n = new Notification(title, {
        icon: '/favicon.svg',
        badge: '/favicon.svg',
        ...options,
      });
      if (options?.onClick) {
        n.onclick = () => {
          window.focus();
          options.onClick?.();
          n.close();
        };
      }
      // Auto close sau 6s
      setTimeout(() => n.close(), 6000);
    } catch (e) {
      console.warn('[notify] Cannot show notification:', e);
    }
  },

  /** Rung máy (mobile) */
  vibrate(pattern: number | number[] = 200) {
    if ('vibrate' in navigator) {
      navigator.vibrate(pattern);
    }
  },

  /** Kiểm tra permission status */
  isEnabled(): boolean {
    return typeof Notification !== 'undefined' && Notification.permission === 'granted';
  },
};
